const deleteTaskDenied = {
    title: 'Ошибка удаления',
    description: 'Нельзя удалить <b>выполненную</b> задачу',
} as const;

export default deleteTaskDenied;
